// extracted by mini-css-extract-plugin
export default {"animal_chart_container":"AnimalChart_animal_chart_container__efTOj","spin":"AnimalChart_spin__MFBAu"};